import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { StaggerContainer, StaggerItem, SpotlightCard, FadeInUp } from '../../common/AnimationUtils';

import styles from '../styles/PricingSection.module.css';

const PricingCard = ({ plan, price, features }) => {
    return (
        <StaggerItem className={styles.cardWrapper}>
            <SpotlightCard className={styles.card}>
                <h3 className={styles.planName}>{plan}</h3>
                <div className={styles.priceContainer}>
                    <span className={styles.currency}>$</span>
                    <span className={styles.amount}>{price}</span>
                    <span className={styles.period}>/month</span>
                </div>

                <Link to="/subscription" className={styles.button}>
                    View Details
                </Link>

                <ul className={styles.features}>
                    {features.map((feature, index) => (
                        <li key={index} className={styles.featureItem}>
                            <CheckCircle className={styles.checkIcon} />
                            <span>{feature}</span>
                        </li>
                    ))}
                </ul>
            </SpotlightCard>
        </StaggerItem>
    );
};

const PricingSection = () => {
    return (
        <section className={styles.section}>
            <FadeInUp>
                <h2 className={styles.title}>Pricing</h2>
            </FadeInUp>

            <FadeInUp delay={0.1}>
                <p className={styles.description}>
                    We offer a Free plan with 10,000 subscription credits per month and a Plus plan for $15/month with 150,000 subscription credits per month. The Plus plan also includes access to purchased credits - additional credits you can buy to extend your usage beyond the monthly allowance.
                </p>
            </FadeInUp>

            <StaggerContainer className={styles.cardsContainer} staggerChildren={0.2}>
                <PricingCard
                    plan="Free"
                    price="0"
                    features={[
                        "10,000 subscription credits per month",
                        "Access to purchased credits",
                        "Access to all features"
                    ]}
                />
                <PricingCard
                    plan="Plus"
                    price="15"
                    features={[
                        "150,000 subscription credits per month",
                        "Access to purchased credits",
                        "Access to all features"
                    ]}
                />
            </StaggerContainer>
        </section>
    );
};

export default PricingSection;
